/**
 * Edges cujos corpos de request/response carregam chave de API em texto puro (BYOKU-10).
 * O replay de sessão do PostHog nunca grava esses requests.
 */
export const SECRET_EDGE_PATHS = [
  '/functions/v1/ai-user-keys',
  '/functions/v1/ai-system-keys-admin',
  '/functions/v1/ai-providers-admin',
] as const

const isSecretEdgeUrl = (name: string): boolean =>
  SECRET_EDGE_PATHS.some((path) => {
    const idx = name.indexOf(path)
    if (idx === -1) return false
    const next = name.charAt(idx + path.length)
    return next === '' || next === '/' || next === '?' || next === '#'
  })

/** `session_recording.maskCapturedNetworkRequestFn`: devolve `null` para requests das Edges de chave. */
export function dropSecretNetworkRequest<R extends { name?: string }>(request: R): R | null {
  return typeof request.name === 'string' && isSecretEdgeUrl(request.name) ? null : request
}
